import { createAsyncThunk } from '@reduxjs/toolkit';

const getParams = (filters) => {
  const params = {
    filter_by: {
      date: {
        from: filters?.from,
      },
    },
    date_group: filters?.date_group,
    group_by_1: filters?.group_by,
    group_by_2: filters?.break_down || 'gender',
  };

  if (filters?.to) {
    params['filter_by']['date']['to'] = filters?.to;
  }

  if (filters?.c_to || filters?.c_from) {
    if (filters?.c_to) {
      const compare = {
        date: {
          to: filters?.c_to,
        },
      };
      params['compare'] = compare;
    }
    if (filters?.c_from) {
      const compare = {
        date: {
          from: filters?.c_from,
        },
      };
      params['compare'] = compare;
    }
  }

  if (filters?.recruiter_id?.length) {
    const ids = filters?.recruiter_id?.map((r) => r?.id);
    const condition = filters?.recruiter_id_condition?.id;
    params.filter_by['recruiter_id'] = {
      [condition]: ids,
    };
  }

  if (filters?.flow_id?.length) {
    const ids = filters?.flow_id?.map((r) => r?.id);
    const condition = filters?.flow_id_condition?.id;
    params.filter_by['flow_id'] = {
      [condition]: ids,
    };
  }

  if (filters?.department_id?.length) {
    const ids = filters?.department_id?.map((r) => r?.id);
    const condition = filters?.department_id_condition?.id;
    params.filter_by['ats_department_id'] = {
      [condition]: ids,
    };
  }

  if (filters?.job_id?.length) {
    const ids = filters?.job_id?.map((r) => r?.id);
    const condition = filters?.job_id_condition?.id;
    params.filter_by['ats_job_id'] = {
      [condition]: ids,
    };
  }

  return params;
};

const getDiversity = async (payload = {}, { extra: { http } }) => {
  try {
    const { filters } = payload;
    const params = getParams(filters);
    const result = await http.post('/reports/diversity_distribution', params);
    return result?.data;
  } catch {}
};

export const fetchDiversityDistribution = createAsyncThunk(
  'reportsv2/diversity/fetch',
  getDiversity
);

const getDrilldownParams = (selected) => {
  const {
    id: metric,
    row: { depth = 0, original: row },
  } = selected;

  const params = {};
  params['metric'] = metric;

  if (row?.g1 !== null) {
    params['g1'] =
      depth === 0
        ? row?.group_by?.id || row?.group_by
        : row?.parent?.id || row?.parent;
  } else {
    params['dt'] =
      depth === 0
        ? row?.group_by?.id || row?.group_by
        : row?.parent?.id || row?.parent;
  }
  if (row?.g2 !== null) {
    params['g2'] = row?.group_by?.id || row?.group_by;
  }
  return params;
};

const getDrilldown = async (payload = {}, { extra: { http } }) => {
  try {
    const { filters, selected } = payload;
    const params = getParams(filters);
    const drilldown = getDrilldownParams(selected);
    const result = await http.post(
      '/reports/diversity_distribution/drilldown',
      {
        ...params,
        drilldown,
      }
    );
    return result?.data;
  } catch (e) {}
};

export const fetchDrilldown = createAsyncThunk(
  'reportsv2/diversity/drilldown',
  getDrilldown
);
